import { useMutation } from "@tanstack/react-query";

import {
  AuditTrailAuthEventType,
  AuditTrailDownloadEventRecordType,
} from "@libs/api/patients";

import { AuditTrailsApi } from "../api/auditTrailsApi";

export const useRecordAuthEventMutation = (
  eventType: AuditTrailAuthEventType,
) => {
  return useMutation({
    mutationFn: () => AuditTrailsApi.recordAuthEvent(eventType),
  });
};

export const useRecordDownloadEventMutation = () => {
  return useMutation({
    mutationFn: (body: {
      type: AuditTrailDownloadEventRecordType;
      id: string;
    }) => AuditTrailsApi.recordDownloadEvent(body),
  });
};
